'use client'

import Heading from '@/components/Heading/Heading'
import PricingForm from '../PricingForm'

export default function Home() {
  return (
    <div className="flex w-full bg-white gap-[32px]">
      <div className="flex-grow">
        <Heading
          title={'Add a new price'}
          description={''}
          parent={{
            title: 'Pricing',
            url: '/pricing',
          }}
        >
        </Heading>
        <PricingForm />
      </div>
    </div>
  )
}
